import React from "react"
import { cn } from "../lib/utils"
import { Badge } from "./ui/badge"

type StatusVariant ="default"|"success"|"warning"|"destructive"|"info"|"secondary"|"neutral"|"active"|"inactive"|"pending"

interface StatusBadgeProps {
 variant?: StatusVariant
 dot?: boolean
 children: React.ReactNode
 className?: string
}

const variantMap: Record<StatusVariant, React.ComponentProps<typeof Badge>["variant"]> = {
 default:"default",
 success:"success",
 warning:"warning",
 destructive:"destructive",
 info:"info",
 secondary:"secondary",
 neutral:"neutral",
 active:"success",
 inactive:"neutral",
 pending:"warning",
}

const dotClassByVariant: Record<StatusVariant, string> = {
 default: "bg-primary-foreground/90",
 success: "bg-semantic-success-solid-fg/90",
 warning: "bg-semantic-warning-solid-fg/90",
 destructive: "bg-semantic-danger-solid-fg/90",
 info: "bg-semantic-info-solid-fg/90",
 secondary: "bg-semantic-slate-solid-fg/90",
 neutral: "bg-semantic-slate-solid-fg/90",
 active: "bg-semantic-success-solid-fg/90",
 inactive: "bg-semantic-slate-solid-fg/90",
 pending: "bg-semantic-warning-solid-fg/90",
}

export function StatusBadge({ variant ="default", dot, children, className }: StatusBadgeProps) {
 return (
 <Badge
 variant={variantMap[variant] || "secondary"}
 className={cn("font-medium gap-1.5", className)}
 >
 {dot && (
 <span
 className={cn(
"h-1.5 w-1.5 shrink-0 rounded-full",
 dotClassByVariant[variant] ?? "bg-foreground/80")}
 />
 )}
 {children}
 </Badge>
 )
}
